/**
 * Results API
 * Manages health check results and summaries
 */
export function createResultsApi(registry) {
    return {
        /**
         * Get all health check results
         * @returns Map of checkId -> result
         */
        get: () => {
            return registry.getResults();
        },
        /**
         * Clear all cached results
         * Forces fresh execution on next check run
         */
        clear: () => {
            registry.clearResults();
        },
        /**
         * Get summary statistics of health check results
         * @returns Summary object with counts, statuses, etc.
         */
        getSummary: () => {
            return registry.getSummary();
        },
    };
}
